import { SkeletonContactCard } from './SkeletonContactCard';

export function ContactsSkeleton() {
  return (
    <div className="grid grid-cols-2 gap-md">
      <SkeletonContactCard
        cardWidth="w-[14.5em]"
        titleClassName="h-[12px] w-[5em]"
        infoClassName="h-[20px] w-[13em]"
      />
      <SkeletonContactCard
        cardWidth="w-[14.5em]"
        titleClassName="h-[12px] w-[5em]"
        infoClassName="h-[20px] w-[13em]"
      />
    </div>
  );
}

ContactsSkeleton.displayName = 'ContactsSkeleton';
